import styled, { css } from 'styled-components';

import { Div } from '../helpers/StyledUtils';
import { CONTAINER_WIDTHS } from '@hookdeck/theme';

interface Props {
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  xlarge?: boolean;
  xxlarge?: boolean;
  center?: boolean;
  left?: boolean;

  stretch?: boolean;

  muted?: boolean;
}

const Container = styled(Div)<Props>(({ theme, center, left, muted, ...props }) => {
  const width = Object.keys(CONTAINER_WIDTHS).find((key) => props[key]);
  return css`
    margin: ${left ? '0' : '0 auto'};
    width: 100%;
    padding: 0 ${theme.spacing(6)};
    box-sizing: border-box;
    background-color: ${muted ? theme.colors.surface.base.variant_surface_3 : 'transparent'};
    box-shadow: ${muted ? theme.shadows.neutral.base : 'none'};
    ${center
      ? css`
          text-align: center;
        `
      : ''}

    ${props.stretch
      ? css`
          width: ${width
            ? theme.pxToRem(CONTAINER_WIDTHS[width] + theme.grid_size * 6 * 2)
            : '100%'};
        `
      : ''}
    max-width: ${width ? theme.pxToRem(CONTAINER_WIDTHS[width] + theme.grid_size * 6 * 2) : '100%'};
  `;
});

export default Container;
